export const MIN_SELECTION_DURATION = 2;

export const MAX_SELECTION_DURATION = 5;

/**
 * Duration the selection starts at. Kept separate from MAX_SELECTION_DURATION
 * so changing the max does not silently change the default.
 */
export const DEFAULT_SELECTION_DURATION = 5;

/** Decimal places used when rounding times internally (not for display). */
export const TIME_PRECISION = 2;

/** Keyboard nudge, used for both sliding the window and resizing it. */
export const KEYBOARD_STEP_SECONDS = 0.1;
export const KEYBOARD_SHIFT_STEP_SECONDS = 1;

export const TIMELINE_MAX_THUMBNAILS = 16;

export const FILMSTRIP_STRIP_HEIGHT = 40;

export const VERTICAL_OVERRIDE_THUMBNAIL_COUNT = 16;

export const VERTICAL_THUMBNAIL_HEIGHT_RATIO = 1.6;
